<p-dropdown
  [options]="dropdownOptions"
  [(ngModel)]="selectedRegion"
  optionLabel="label"
  optionValue="value"
  placeholder="Select"
  styleClass="regions-dropdown"
  panelStyleClass="levels-dropdown-panel"
  appendTo="body"
  (onChange)="onLevelChange()"
></p-dropdown>

